import Account from "@/app/user/account/account.page";
import Notification from "@/app/user/notification/notification.page";
import ChangePasswordPage from "@/app/user/change-password/change-password.page";

export const user_routes = [
  {
    path: "/user/account",
    element: <Account />,
  },
  {
    path: "/user/notification",
    element: <Notification />,
  },
  {
    path: "/user/change-password",
    element: <ChangePasswordPage />,
  },
];
